import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getOfficeStatus } from "@/lib/utils/get-office-status";
import { WorkingHour } from "@/app/types/common";
import { BffFacilityLocation } from "@/lib/__generated/beffe-sdk";

const OfficeStatus = ({
	workingHours,
	distance,
	isVariantB,
	timeZone,
}: {
	workingHours: WorkingHour[];
	distance?: BffFacilityLocation["distance"];
	isVariantB?: boolean;
	timeZone?: string | null;
}) => {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const message = getOfficeStatus(workingHours, timeZone ?? undefined);
	const [prefix, suffix] = message.split("•");

	const isOpen = message.toLowerCase().startsWith("open");

	return (
		<Box sx={{ textAlign: "left" }}>
			{isVariantB ? (
				<>
					<Typography
						variant="bodySBold"
						sx={{ color: isOpen ? "success.main" : "error.main" }}
					>
						{prefix.trim()}
					</Typography>
					<Typography
						variant="bodyS"
						sx={{ color: "text.primary" }}
						component="span"
					>
						{" •"}
					</Typography>
				</>
			) : (
				<Typography
					variant={isSmallScreen ? "bodySBold" : "bodyS"}
					sx={{ color: isOpen ? "success.main" : "error.main" }}
				>
					{prefix.trim()} •
				</Typography>
			)}{" "}
			<Typography variant="bodyS">{suffix?.trim()}</Typography>
			{distance ? (
				<Box component="span" sx={{ color: "text.primary" }}>
					{` • ${distance.toFixed(1)} mi`}
				</Box>
			) : null}
		</Box>
	);
};

export default OfficeStatus;
